@if (isAdmin || isDepartmentAdmin) {

<div class="container">
  <div class="mat-elevation-z8">
    <form [formGroup]="userForm" (ngSubmit)="onSave()" class="user-form">
      <h2>User Details</h2>

      <div class="form-row">
        <div class="field">
          <mat-form-field appearance="outline">
            <mat-label>User Name</mat-label>

            <input matInput formControlName="userName" required>

            @if (userForm.get('userName')?.invalid && userForm.get('userName')?.touched) {
            <mat-error>
              User Name is required
            </mat-error>
            }

          </mat-form-field>
        </div>

        <div class="field">
          <mat-form-field appearance="outline">
            <mat-label>First Name</mat-label>
            <input matInput formControlName="firstName" required>
            @if (userForm.get('firstName')?.invalid && userForm.get('firstName')?.touched) {
            <mat-error>
              First Name is required
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="field">
          <mat-form-field appearance="outline">
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="lastName" required>
            @if (userForm.get('lastName')?.invalid && userForm.get('lastName')?.touched) {
            <mat-error>
              Last Name is required
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="field">
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>

            <input matInput formControlName="email" (blur)="checkEmail()">

            <mat-error *ngIf="userForm.get('email')?.hasError('required') && userForm.get('email')?.touched">
              Email is required
            </mat-error>
            <mat-error
              *ngIf="!userForm.get('email')?.hasError('required') && userForm.get('email')?.hasError('invalidEmail')">
              Enter valid Email Address
            </mat-error>

          </mat-form-field>
        </div>

        <div class="field">
          <mat-form-field appearance="outline">
            <mat-label>Contact</mat-label>
            <input matInput formControlName="contact" maxlength="12" required>
            @if (userForm.get('contact')?.invalid && userForm.get('contact')?.touched) {
            <mat-error>
              Contact is required
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="field">
          <mat-form-field appearance="outline">
            <mat-label>Department</mat-label>
            <mat-select formControlName="departmentId" (selectionChange)="onDepartmentChange($event.value)" required>
              <mat-option *ngFor="let department of departments" [value]="department.id">{{ department.departmentName
                }}</mat-option>

            </mat-select>
            @if (userForm.get('departmentId')?.invalid && userForm.get('departmentId')?.touched && selectedRole !== roleNameEnum.ADMIN ) {
            <mat-error>
              Department is required
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="field">
          <mat-form-field appearance="outline">
            <mat-label>Employee Code</mat-label>
            <input matInput formControlName="employeeCode">
            @if (userForm.get('employeeCode')?.invalid && userForm.get('employeeCode')?.touched) {
            <mat-error>
              Employee Code is required
            </mat-error>
            }
          </mat-form-field>
        </div>

      <div class="field">
        <mat-form-field appearance="outline">
          <mat-label>Joining Date</mat-label>
      
          <input matInput [matDatepicker]="joiningDatePicker" formControlName="joiningDate" required>
      
          <mat-datepicker-toggle matSuffix [for]="joiningDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #joiningDatePicker></mat-datepicker>
      
          <mat-error *ngIf="userForm.get('joiningDate')?.hasError('required') && userForm.get('joiningDate')?.touched">
            Joining Date is required
          </mat-error>
      
          <mat-error
            *ngIf="!userForm.get('joiningDate')?.hasError('required') && userForm.hasError('ageInvalid') && userForm.get('joiningDate')?.touched">
            Employee must be at least 18 years old
          </mat-error>
      
        </mat-form-field>
      </div>
      
      <div class="field">
        <mat-form-field appearance="outline">
          <mat-label>Birth Date</mat-label>
      
          <input matInput [matDatepicker]="birthDatePicker" formControlName="birthDate">
      
          <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #birthDatePicker></mat-datepicker>
      
          <mat-error *ngIf="userForm.get('birthDate')?.hasError('required') && userForm.get('birthDate')?.touched">
            Birth Date is required
          </mat-error>

          <mat-error *ngIf="userForm.hasError('invalidDOB') && userForm.get('birthDate')?.touched">
            Date of Birth cannot be after Joining Date
          </mat-error>
      
        </mat-form-field>
      </div>

        <div class="field">
          <mat-form-field appearance="outline">
            <mat-label>Role</mat-label>
            <mat-select formControlName="role" (selectionChange)="onRoleChange($event)" required>
              <mat-option *ngFor="let role of roles" [value]="role.role">{{ role.role }}</mat-option>
            </mat-select>
            @if (userForm.get('role')?.invalid && userForm.get('role')?.touched) {
            <mat-error>
              Role is required
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="field" *ngIf="selectedRole === 'EMPLOYEE' || selectedRole === 'TEAMLEAD'">
          <mat-form-field appearance="outline">
            <mat-label>Teamlead</mat-label>
            <mat-select formControlName="teamleads" multiple [disabled]="filteredTeamleads.length === 0">
              <mat-option *ngFor="let teamlead of filteredTeamleads" [value]="teamlead">{{ teamlead.name }}</mat-option>
            </mat-select>
            @if (userForm.get('teamleads')?.invalid && userForm.get('teamleads')?.touched) {
            <mat-error>
              Teamlead is required
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="field">
          <mat-form-field appearance="outline">
            <mat-label>Employee Type</mat-label>
            <mat-select formControlName="employeeType" required>
              <mat-option *ngFor="let employeeType of employeeTypes" [value]="employeeType.employeeType">{{
                employeeType.employeeType }}</mat-option>
            </mat-select>
            @if (userForm.get('employeeType')?.invalid && userForm.get('employeeType')?.touched) {
            <mat-error>
              Employee Type is required
            </mat-error>
            }
          </mat-form-field>
        </div>
        <button mat-raised-button color="primary" type="submit"
          [disabled]="isSubmitting || userForm.invalid">Submit</button>
      </div>
      <!-- end of form-row -->

      <div *ngIf="isSubmitting" class="loading">
        <mat-spinner diameter="30"></mat-spinner>
        <span>Submitting...</span>
      </div>

    </form>
    <!-- User List (Moved to UserListComponent) -->
    <app-user-list></app-user-list>
  </div>
</div>

}
@else if (isTeamlead || isDepartmentAdmin) {
<app-user-list></app-user-list>
}
@else {
<p>You are not authorized.</p>
}